define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/locale",
	"csi/xml",
	"csi/xml/Query",
	"csi/action/FormData",
	"csi/store/Nodes",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin"
], function(array, declare, lang, _, locale, xml, Query, FormData, Nodes, NewFrom, ActionControllerMixin) {

	var SELECT_INSPECTION_PAGE = 0;
	var SELECT_SECTIONS_PAGE = 1;

	return declare([NewFrom, ActionControllerMixin], {
		_fdSections: null,

		/**
		 * Only one selection is allowed
		 * @param {FormData} fd
		 */
		onFormData: function(fd) {
			fd.m_bSelectOne = true;
		},

		_preAction: function() {
			// summary: request for section subtypes used on the current inspection, so that only those unused could be selected
			this.inspection = this.widget.getViewNode();
			this.subtypesStore = new Nodes({
				typeNode: "FinalInspectionSectionSubtype",
				requestParameters: {
					"Qry.Limit.Path": xml.getUrlPath(this.inspection.$URL, xml.path("Sections", "Subtype"))
				}
			});

			return this.subtypesStore.query();
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for BOM-lines view
			var q = this.inherited(arguments);

			if (index == 0) {
				// filter our the same inspection or inspection template
				q = new Query();
				q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, this.inspection.$URL);
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard, /*Content*/currentPage, /*Content*/nextPage, /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var nPage = wizard.getIndexOfPage(nextPage);
			var dfd, fd;
			var bRefresh = false;

			switch (nPage) {
				case SELECT_INSPECTION_PAGE:
					// use controller's form data to select product
					fd = this.m_formData;
					fd.m_bRequireOne = true;
					break;

				case SELECT_SECTIONS_PAGE:
					this.inspection = this.m_formData.getSelectedNode();

					// initialize form data if not already done - this page uses form data from this controller
					fd = this._fdSections = this._fdSections || new FormData(this);

					fd.m_fAggregateTest = lang.hitch(this, this._canSelectSection);

					// if form data node has changed, then reset selections and refresh view
					if (fd.getNode() != this.inspection) {
						fd.resetSelections();
						fd.setNode(this.inspection);
						bRefresh = true;
					}

					break;
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		_canSelectSection: function(/*Context*/ctx, /*FormData*/fd) {
			// allow sections for selection that have different Subtype from already existing sections	
			return !this.subtypesStore.get(ctx.getNode().Subtype);
		},

		toWriterRequest: function() {
			// summary: add colors parameter
			// force nodes to be returned from java operation
			this.m_action.returnParams = false;

			var call = this.inherited(arguments);
			call.addParameter("SectionsURLs", xml.ATTR_REFLIST, this._fdSections.getSelectedValue());
			return call;
		},

		_getFormView: function(/*Boolean*/bCheckOnly) {
			// do not display the FinalInspectionForm
			return null;
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			if (this.m_response) {
				return _.filter(this.m_response.getNodes(), function(node) {return node.$Type == "FinalInspectionSection";})
			}
			return this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: refresh data in the sections table
			this._newPostProcess();
		},

		/**
		 * @override
		 * customize the successful message
		 */
		getSuccess: function() {
			const isSingle = this._sourceSelectedLength == 1;
			const type = this.m_action.m_typeNodeHint;
			const text = isSingle ? locale.type(type) : locale.resource("ConjunctionNumberOfType", [this._sourceSelectedLength, locale.typePlural(type)]);

			return locale.resource("New_Success", [text]);
		}
	});
});